import { render, staticRenderFns } from "./DettaglioPassword.vue?vue&type=template&id=ea489fa6"
import script from "./DettaglioPassword.vue?vue&type=script&lang=js"
export * from "./DettaglioPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports